import React from 'react';

import { Page } from 'components/layouts';

import RichText from 'components/rich-text';
import Button from 'components/button';
import Alert from 'components/alert';
import Input from 'components/input';
import TextArea from 'components/text-area';
import RadioButtonGroup from 'components/radio-button-group';
import RadioButton from 'components/radio-button-group/radio-button';
import Card from 'components/card';
import CardRow from 'components/card-row';
import Avatar from 'components/avatar';
import Select from 'components/select';

import './style.css';

export const options = [
  {
    label: 'Option A',
    value: 'a',
  },
  {
    label: 'Option B',
    value: 'b',
  },
  {
    label: 'Option C',
    value: 'c',
  },
  {
    label: 'Option D',
    value: 'd',
  },
];

const colors = [
  {
    name: 'main-01',
    hex: '#33f4f9',
    variable: 'var(--color-main-01)',
  },
  {
    name: 'main-02',
    hex: '#abccee',
    variable: 'var(--color-main-02)',
  },
  {
    name: 'main-03',
    hex: '#7ba9dc',
    variable: 'var(--color-main-03)',
  },
  {
    name: 'main-04',
    hex: '#93b7e2',
    variable: 'var(--color-main-04)',
  },
  {
    name: 'main-05',
    hex: '#6d8dc1',
    variable: 'var(--color-main-05)',
  },
  {
    name: 'main-06',
    hex: '#00458e',
    variable: 'var(--color-main-06)',
  },
  {
    name: 'main-07',
    hex: '#09124b',
    variable: 'var(--color-main-07)',
  },
];

const colorsAlt = [
  {
    name: 'success-01',
    hex: '#c2d488',
    variable: 'var(--color-success-01)',
  },
  {
    name: 'success-02',
    hex: '#4e8a23',
    variable: 'var(--color-success-02)',
  },
  {
    name: 'warning-01',
    hex: '#f5e68b',
    variable: 'var(--color-warning-01)',
  },
  {
    name: 'warning-02',
    hex: '#ffe744',
    variable: 'var(--color-warning-02)',
  },
  {
    name: 'danger-01',
    hex: '#ed8c95',
    variable: 'var(--color-danger-01)',
  },
  {
    name: 'danger-02',
    hex: '#e03039',
    variable: 'var(--color-danger-02)',
  },
  {
    name: 'info-01',
    hex: '#c6a0cb',
    variable: 'var(--color-info-01)',
  },
  {
    name: 'info-02',
    hex: '#b38ec1',
    variable: 'var(--color-info-02)',
  },
];

const Design = () => {
  return (
    <Page className="page -design">
      <section className="texts">
        <RichText>
          <h1>Header 1</h1>
          <h2>Header 2</h2>
          <h3>Header 3</h3>
          <h4>Header 4</h4>
          <h5>Header 5</h5>

          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras
            faucibus consequat tortor. Donec feugiat vitae mauris ut rutrum.
            Quisque eu maximus massa. Sed hendrerit lacus ac tortor tristique,
            ullamcorper lobortis mi accumsan. Nulla facilisi. Nullam dignissim
            diam et odio efficitur imperdiet. Nullam pretium dui augue, sit amet
            pretium sem maximus bibendum. Cras accumsan rhoncus luctus. Sed in
            feugiat ligula, ac viverra tortor. Cras porttitor lobortis diam eget
            euismod.
          </p>

          <p>
            Sed vitae mi mauris. Sed vulputate lobortis turpis, a pretium nisi
            sodales et. Ut sed rhoncus urna. Donec eu rhoncus ante, sed eleifend
            erat. Cras eu urna in justo iaculis luctus. Donec sit amet lacus a
            nisi eleifend pharetra in ut ante. Nam id tristique lectus. Nam id
            arcu sapien.
          </p>

          <p>
            Nullam eget molestie tellus, ac scelerisque nisi. Aenean eu turpis
            at urna lacinia interdum. In in augue interdum, aliquet tellus ut,
            sodales turpis. Duis vitae erat non magna porta finibus vel id
            magna. Sed blandit in sapien nec malesuada. Nullam a est eros.
            Quisque a sapien nisi. Sed auctor elit eu fermentum mollis. Proin
            erat enim, egestas ut felis ac, mattis porttitor massa. Maecenas
            nibh lectus, gravida non sapien non, convallis sagittis felis. Donec
            lectus ex, ultricies id ante in, gravida iaculis ipsum.
          </p>
        </RichText>
      </section>

      <section className="small-text">
        <span>Small Text for navigation</span>
      </section>

      <hr />

      <section className="buttons">
        <h4>Large</h4>
        <div className="buttons-grid">
          <Button hierarchy="primary" size="l">
            Primary
          </Button>
          <Button hierarchy="secondary" size="l">
            Secondary
          </Button>
          <Button hierarchy="tertiary" size="l">
            Tertiary
          </Button>
        </div>
      </section>
      <section className="buttons">
        <h4>Normal</h4>
        <div className="buttons-grid">
          <Button hierarchy="primary">Primary</Button>
          <Button hierarchy="secondary">Secondary</Button>
          <Button hierarchy="tertiary">Tertiary</Button>
        </div>
      </section>
      <section className="buttons">
        <h4>No shadow</h4>
        <div className="buttons-grid">
          <Button hierarchy="primary" shadow={false}>
            Primary
          </Button>
          <Button hierarchy="secondary" shadow={false}>
            Secondary
          </Button>
          <Button hierarchy="tertiary" shadow={false}>
            Tertiary
          </Button>
        </div>
      </section>

      <section className="buttons">
        <h4>Disabled</h4>
        <div className="buttons-grid">
          <Button hierarchy="primary" disabled>
            Primary
          </Button>
          <Button hierarchy="secondary" disabled>
            Secondary
          </Button>
          <Button hierarchy="tertiary" disabled>
            Tertiary
          </Button>
        </div>
      </section>

      <section className="buttons">
        <h4>Small</h4>
        <div className="buttons-grid">
          <Button hierarchy="primary" size="s">
            Primary
          </Button>
          <Button hierarchy="secondary" size="s">
            Secondary
          </Button>
          <Button hierarchy="tertiary" size="s">
            Tertiary
          </Button>
        </div>
      </section>

      <hr />

      <section className="colors">
        {colors.map(({ variable, hex, name }) => {
          return (
            <div className="color-container" key={name}>
              <span className="color" style={{ background: variable }} />
              <span className="hex">{hex}</span>
              <span className="name">{name}</span>
            </div>
          );
        })}
      </section>

      <section className="colors">
        {colorsAlt.map(({ variable, hex, name }) => {
          return (
            <div className="color-container" key={name}>
              <span className="color" style={{ background: variable }} />
              <span className="hex">{hex}</span>
              <span className="name">{name}</span>
            </div>
          );
        })}
      </section>

      <section className="gradients">
        <div className="gradient" />
      </section>

      <hr />

      <section className="alerts">
        <Alert type="warning" message="Warning" />
        <Alert type="success" message="Success" />
        <Alert type="info" message="Info" />
        <Alert type="error" message="Error" />
      </section>

      <section className="forms">
        <div className="form">
          <Input placeholder="Input" />
          <TextArea placeholder="TextArea" rows={2} />
          <TextArea placeholder="TextArea" looks="input" />
          <TextArea placeholder="TextArea" looks="white" rows={2} />

          <RadioButtonGroup initial={null}>
            <RadioButton label="Option A" option="a" />
            <RadioButton label="Option B" option="b" />
            <RadioButton label="Option C" option="c" />
          </RadioButtonGroup>

          <Select isClearable options={options} placeholder="Select" />
        </div>

        <div className="form -alt">
          <Input placeholder="Input" />
          <TextArea placeholder="TextArea" rows={2} />
          <TextArea placeholder="TextArea" looks="input" />
          <TextArea placeholder="TextArea" looks="white" rows={2} />

          <RadioButtonGroup initial={null}>
            <RadioButton label="Option A" option="a" />
            <RadioButton label="Option B" option="b" />
            <RadioButton label="Option C" option="c" />
          </RadioButtonGroup>
          <Select isClearable options={options} placeholder="Select" />
        </div>
      </section>

      <hr />

      <section className="avatars">
        <Avatar src="https://i.pravatar.cc/300" size="l" />
        <Avatar src="https://i.pravatar.cc/300" size="m" />
        <Avatar src="https://i.pravatar.cc/300" size="s" />
      </section>

      <section className="card-rows">
        <CardRow>Card Row</CardRow>
        <CardRow looks="admin">Card Row</CardRow>
      </section>

      <section className="cards">
        <Card title="a">
          <TextArea placeholder="Write here" looks="transparent" />
        </Card>
        <Card title="a" shadow={false}>
          <TextArea placeholder="Write here" looks="transparent" />
        </Card>
      </section>
    </Page>
  );
};

export default Design;
